import { Modal } from '@brighterion/br-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.css';

type Props = {
    isOpen: boolean;
    closeModal: () => void;
    createReport: () => void;
};

export const SaveReportErrorModal = ({ isOpen, closeModal, createReport }: Props) => {
    const { t } = useTranslation();
    return (
        <Modal isOpen={isOpen} closeModal={closeModal} status='error' containerClass={styles.containerClass}>
            <Modal.Title
                id='create-report-error-modal-title'
                statusIcon='error'
                title={t('Save Error')}
                onClose={closeModal}
            />
            <div className={styles.errModalContent}>
                {t('There was an unexpected error saving your report Would you like to try saving this report again')}
            </div>
            <Modal.Footer
                id='create-report-error-modal-footer'
                onClose={closeModal}
                onCloseText={t('No')}
                onAction={createReport}
                onActionText={t('Yes')}
            />
        </Modal>
    );
};
